module.exports = __webpack_public_path__ + "static/Seal_of_the_United_States_Department_of_Health_and_Human_Services-9114787907644a3025ca705e8479421e.svg";